'use strict';
const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    /**
     * Default attributes
     */
    defaults: {
        // Time values
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        // Timer settings
        addZeros: true,
        enableDays: false,
        endTime: null,
        endTimestamp: null,
        isResetting: false,
        timerEnded: true
    },
    /**
     * Initialize countdown model
     */
    initialize: function(attrs, options) {
        this.cms = options.cms;
        this.listenTo(this.cms, 'change:sid', this._updateTS.bind(this));
        this._setDefaults();
        this._updateTS();
        this.lastAnimateTimestamp = 0;
    },
    /**
     * Calculate for the time remaining
     */
    getTimeRemaining: function() {
        var elapsedTime = new Date().getTime() - this.cms.get('localTime');
        var startTime = this.cmsLastTS + elapsedTime;
        var endTime = new Date(this.get('endTime')).getTime();
        return parseInt((endTime - startTime) / 1000, 10);
    },
    /**
     * Start the countdown timer
     */
    startCountdown: function() {
        this.lastAnimateTimestamp = 0;
        this.set({ timerEnded: false }, { silent: true });
        this._countdown();
    },
    /**
     * Stop the countdown timer
     */
    stopCountdown: function() {
        this._setDefaults();
    },
    /**
     * Calculate the time remaining
     */
    _countdown: function(currentTimestamp) {
        // Make sure there is an endTime set
        if(!this.get('endTime')) return;

        //Return if less than a second has passed.
        if( this.lastAnimateTimestamp && (currentTimestamp - this.lastAnimateTimestamp < 1000) ) {
            requestAnimationFrame(this._countdown.bind(this));
            return;
        } else {
            this.lastAnimateTimestamp = currentTimestamp;
        }

        // Calculate the time remaining in seconds
        var timeRemaining = this.getTimeRemaining();

        if((this.get('isResetting') && timeRemaining > 0) || (!this.get('isResetting') && timeRemaining >= 0)) {

            // Days can be toggled depending on what's needed for the project
            var days = this.get('enableDays') ? parseInt((timeRemaining / 86400), 10) : this.get('days');
            if(this.get('enableDays')) timeRemaining = (timeRemaining % 86400);

            var hours = parseInt((timeRemaining / 3600), 10);
            timeRemaining = (timeRemaining % 3600);
            var minutes = parseInt((timeRemaining / 60), 10);
            timeRemaining = (timeRemaining % 60);
            var seconds = parseInt(timeRemaining, 10);

            // Set the new time values
            var addZeros = this.get('addZeros');
            this.set({
                days: days,
                hours: addZeros ? ('0' + hours).slice(-2) : hours,
                minutes: addZeros ? ('0' + minutes).slice(-2) : minutes,
                seconds: addZeros ? ('0' + seconds).slice(-2) : seconds
            });

            requestAnimationFrame(this._countdown.bind(this));

        } else {
            // Stop the timer once it reaches the endTime
            this.stopCountdown();
        }
    },
    /**
     * Set default values
     */
    _setDefaults: function() {
        var defaultValue = this.get('addZeros') ? '00' : 0;
        this.set({
            days: 0,
            hours: defaultValue,
            minutes: defaultValue,
            seconds: defaultValue,
            timerEnded: true
        });
    },
    /**
     * Update the server TS upon CMS snapshot change
     */
    _updateTS: function() {
        this.cmsLastTS = this.cms.get('ts');
    }
});


// WEBPACK FOOTER //
// ./app/scripts/models/timer.js